import React from 'react';
import { classNames } from '@fullstory/util/fmt';
import { BOX_LEFT_RIGHT_MARGIN, BOX_WIDTH, JOINT_WIDTH } from '../const';
import { GraphNode, RevolveLabel } from '../types';
import { SVGTooltip } from '@fullstory/components';
import css from '../index.module.scss';
import { svgTooltipContent } from './Tooltip';

type ExitBarProps = {
  node: GraphNode;
  height: number;
  offset: number;
  onClick: (e: React.MouseEvent, atDepth: number, label: RevolveLabel) => void;
  dimmed: boolean;
};

export const ExitBar = ({ height, offset, onClick, node, dimmed }: ExitBarProps) => (
  <SVGTooltip
    data-component="ExitBar"
    tooltipContent={svgTooltipContent('Exits', node.count, node.nextCount)}
  >
    <rect
      id="exitDropOff"
      x={BOX_WIDTH + BOX_LEFT_RIGHT_MARGIN}
      y={offset}
      width={JOINT_WIDTH}
      height={height}
      className={classNames(css.exitDropOff, css.click, {
        [css.dimmed]: dimmed,
      })}
      onClick={e => onClick(e, node.depth + 1, RevolveLabel.EXIT)}
    />
  </SVGTooltip>
);
